var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M16.625 1.25h-.875c-.219 0-.375.188-.375.406l.063 3.063A7.64 7.64 0 0 0 8.969 1.28c-4.281 0-7.75 3.5-7.719 7.75 0 4.281 3.469 7.719 7.75 7.719 1.969 0 3.813-.75 5.188-1.969a.396.396 0 0 0 0-.562l-.625-.625c-.125-.125-.344-.125-.5 0A6.06 6.06 0 0 1 9 15.125 6.095 6.095 0 0 1 2.875 9 6.115 6.115 0 0 1 9 2.875c2.469 0 4.594 1.5 5.563 3.625l-3.938-.094a.36.36 0 0 0-.375.375v.844c0 .219.156.375.375.375h6A.38.38 0 0 0 17 7.625v-6a.4.4 0 0 0-.375-.375"
  })));
};
export default SvgRedo;